/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Moderator,
  ModeratorChangePasswordRequest,
  ModeratorTwoFactorDisableRequest,
  ModeratorTwoFactorEnableRequest,
  ModeratorTwoFactorRegenerateRequest,
  PatchedModeratorProfileUpdateRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Self-service profile for the logged-in moderator.

The existing /current/ on ModeratorViewSet is GET-only. This viewset adds
PATCH (update name/phone) and a separate change-password action that
requires the current password — defending against silent takeovers from a
hijacked session.
 * @summary Get my profile
 */
export const moderatorsMeProfileRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/me/profile/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsMeProfileRetrieveQueryKey = () => {
    return [`/api/v1/moderators/me/profile/`] as const;
    }

    
export const getModeratorsMeProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMeProfileRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>> = ({ signal }) => moderatorsMeProfileRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMeProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>>
export type ModeratorsMeProfileRetrieveQueryError = unknown

/**
 * @summary Get my profile
 */
export const useModeratorsMeProfileRetrieve = <TData = Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMeProfileRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMeProfileRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Self-service profile for the logged-in moderator.

The existing /current/ on ModeratorViewSet is GET-only. This viewset adds
PATCH (update name/phone) and a separate change-password action that
requires the current password — defending against silent takeovers from a
hijacked session.
 * @summary Update my profile
 */
export const moderatorsMeProfilePartialUpdate = (
    patchedModeratorProfileUpdateRequest: PatchedModeratorProfileUpdateRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/me/profile/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedModeratorProfileUpdateRequest
    },
      );
    }
  


export const getModeratorsMeProfilePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>, TError,{data: PatchedModeratorProfileUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>, TError,{data: PatchedModeratorProfileUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>, {data: PatchedModeratorProfileUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMeProfilePartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeProfilePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>>
    export type ModeratorsMeProfilePartialUpdateMutationBody = PatchedModeratorProfileUpdateRequest
    export type ModeratorsMeProfilePartialUpdateMutationError = unknown

    /**
 * @summary Update my profile
 */
export const useModeratorsMeProfilePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>, TError,{data: PatchedModeratorProfileUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeProfilePartialUpdate>>,
        TError,
        {data: PatchedModeratorProfileUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMeProfilePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Requires the current password. On success, the existing session is preserved.
 * @summary Change my password
 */
export const moderatorsMeProfileChangePasswordCreate = (
    moderatorChangePasswordRequest: ModeratorChangePasswordRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/me/profile/changePassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorChangePasswordRequest
    },
      );
    }
  


export const getModeratorsMeProfileChangePasswordCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>, TError,{data: ModeratorChangePasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>, TError,{data: ModeratorChangePasswordRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>, {data: ModeratorChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMeProfileChangePasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeProfileChangePasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>>
    export type ModeratorsMeProfileChangePasswordCreateMutationBody = ModeratorChangePasswordRequest
    export type ModeratorsMeProfileChangePasswordCreateMutationError = void

    /**
 * @summary Change my password
 */
export const useModeratorsMeProfileChangePasswordCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>, TError,{data: ModeratorChangePasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeProfileChangePasswordCreate>>,
        TError,
        {data: ModeratorChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMeProfileChangePasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Requires current password and a valid TOTP code.
 * @summary Disable 2FA
 */
export const moderatorsMeTwoFactorDisableCreate = (
    moderatorTwoFactorDisableRequest: ModeratorTwoFactorDisableRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/me/twoFactor/disable/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorTwoFactorDisableRequest
    },
      );
    }
  


export const getModeratorsMeTwoFactorDisableCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>, TError,{data: ModeratorTwoFactorDisableRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>, TError,{data: ModeratorTwoFactorDisableRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>, {data: ModeratorTwoFactorDisableRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMeTwoFactorDisableCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeTwoFactorDisableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>>
    export type ModeratorsMeTwoFactorDisableCreateMutationBody = ModeratorTwoFactorDisableRequest
    export type ModeratorsMeTwoFactorDisableCreateMutationError = unknown

    /**
 * @summary Disable 2FA
 */
export const useModeratorsMeTwoFactorDisableCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>, TError,{data: ModeratorTwoFactorDisableRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeTwoFactorDisableCreate>>,
        TError,
        {data: ModeratorTwoFactorDisableRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMeTwoFactorDisableCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Self-service profile for the logged-in moderator.

The existing /current/ on ModeratorViewSet is GET-only. This viewset adds
PATCH (update name/phone) and a separate change-password action that
requires the current password — defending against silent takeovers from a
hijacked session.
 * @summary Enable 2FA
 */
export const moderatorsMeTwoFactorEnableCreate = (
    moderatorTwoFactorEnableRequest: ModeratorTwoFactorEnableRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/me/twoFactor/enable/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorTwoFactorEnableRequest
    },
      );
    }
  


export const getModeratorsMeTwoFactorEnableCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>, TError,{data: ModeratorTwoFactorEnableRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>, TError,{data: ModeratorTwoFactorEnableRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>, {data: ModeratorTwoFactorEnableRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMeTwoFactorEnableCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeTwoFactorEnableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>>
    export type ModeratorsMeTwoFactorEnableCreateMutationBody = ModeratorTwoFactorEnableRequest
    export type ModeratorsMeTwoFactorEnableCreateMutationError = void

    /**
 * @summary Enable 2FA
 */
export const useModeratorsMeTwoFactorEnableCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>, TError,{data: ModeratorTwoFactorEnableRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeTwoFactorEnableCreate>>,
        TError,
        {data: ModeratorTwoFactorEnableRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMeTwoFactorEnableCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Replace existing recovery codes. Requires a valid TOTP code.
 * @summary Regenerate recovery codes
 */
export const moderatorsMeTwoFactorRecoveryCodesRegenerateCreate = (
    moderatorTwoFactorRegenerateRequest: ModeratorTwoFactorRegenerateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/me/twoFactor/recoveryCodes/regenerate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorTwoFactorRegenerateRequest
    },
      );
    }
  


export const getModeratorsMeTwoFactorRecoveryCodesRegenerateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: ModeratorTwoFactorRegenerateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: ModeratorTwoFactorRegenerateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>, {data: ModeratorTwoFactorRegenerateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMeTwoFactorRecoveryCodesRegenerateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeTwoFactorRecoveryCodesRegenerateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>>
    export type ModeratorsMeTwoFactorRecoveryCodesRegenerateCreateMutationBody = ModeratorTwoFactorRegenerateRequest
    export type ModeratorsMeTwoFactorRecoveryCodesRegenerateCreateMutationError = unknown

    /**
 * @summary Regenerate recovery codes
 */
export const useModeratorsMeTwoFactorRecoveryCodesRegenerateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: ModeratorTwoFactorRegenerateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeTwoFactorRecoveryCodesRegenerateCreate>>,
        TError,
        {data: ModeratorTwoFactorRegenerateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMeTwoFactorRecoveryCodesRegenerateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Generate a pending TOTP secret. Returns the base32 secret, an `otpauth://` provisioning URI, and a base64 PNG QR code. The secret is only committed once `/twoFactor/enable` verifies a code.
 * @summary Begin 2FA setup
 */
export const moderatorsMeTwoFactorSetupCreate = (
    
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/me/twoFactor/setup/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsMeTwoFactorSetupCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>, void> = () => {
          

          return  moderatorsMeTwoFactorSetupCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMeTwoFactorSetupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>>
    
    export type ModeratorsMeTwoFactorSetupCreateMutationError = unknown

    /**
 * @summary Begin 2FA setup
 */
export const useModeratorsMeTwoFactorSetupCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMeTwoFactorSetupCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getModeratorsMeTwoFactorSetupCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    